import { render } from "./BulkDeleteCohortModal.vue?vue&type=template&id=6ba52e16"
import script from "./BulkDeleteCohortModal.vue?vue&type=script&lang=js"
export * from "./BulkDeleteCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__